export default __webpack_public_path__ + "static/media/removed_users.e274188d.svg";